import { render } from "./UgmRelated.vue?vue&type=template&id=f010d82e&scoped=true"
import script from "./UgmRelated.vue?vue&type=script&lang=js"
export * from "./UgmRelated.vue?vue&type=script&lang=js"

import "./UgmRelated.vue?vue&type=style&index=0&id=f010d82e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f010d82e"]])

export default __exports__